<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                userId
                  ? ("editUser" | translate)
                  : ("createNewUser" | translate)
              }}</span>
            </h3>
          </div>
          <div class="card-body py-3">
            <form [formGroup]="userForm" (ngSubmit)="saveUser($event)">
              <div class="row mb-5 mt-5">
                <!-- Role -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="roleId"
                      class="form-select cursor-pointer"
                      id="inputRole"
                      aria-label="Role"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectRole" | translate }}
                      </option>
                      <option *ngFor="let role of roles" [value]="role.id">
                        {{ role.name }}
                      </option>
                    </select>
                    <label for="inputRole">{{ "role" | translate }}</label>
                    <div *ngIf="isControlInvalid('roleId')" class="text-danger">
                      {{ "roleIsRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Branch -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <select
                      formControlName="branchCode"
                      class="form-select cursor-pointer"
                      id="inputBranch"
                      aria-label="Branch"
                      (change)="onChangeSelectedBranch($event)"
                    >
                      <option [ngValue]="null" disabled>
                        {{ "selectBranch" | translate }}
                      </option>
                      <option
                        *ngFor="let branch of organizationBranchList"
                        [value]="branch.id"
                      >
                        {{ branch.name }}
                      </option>
                    </select>
                    <label for="inputBranch">{{ "branch" | translate }}</label>
                    <div
                      *ngIf="isControlInvalid('branchCode')"
                      class="text-danger"
                    >
                      {{ "branchIsRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Name -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      id="inputName"
                      placeholder="Name"
                      required
                      (input)="preventForbiddenCharacters($event, 'text')"
                    />
                    <label for="inputName">{{ "name" | translate }}</label>
                    <div *ngIf="isControlInvalid('name')" class="text-danger">
                      <ng-container
                        *ngIf="userForm.get('name')?.hasError('required')"
                      >
                        {{ "nameIsRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !userForm.get('name')?.hasError('required') &&
                          userForm.get('name')?.hasError('onlyLetters')
                        "
                      >
                        {{ "nameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Surname -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="surname"
                      type="text"
                      class="form-control"
                      id="inputSurname"
                      placeholder="Surname"
                      (input)="preventForbiddenCharacters($event, 'text')"
                    />
                    <label for="inputSurname">{{
                      "surname" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('surname')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="userForm.get('surname')?.hasError('required')"
                      >
                        {{ "surnameIsRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !userForm.get('surname')?.hasError('required') &&
                          userForm.get('surname')?.hasError('onlyLetters')
                        "
                      >
                        {{ "surnameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- AGB Code -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="pid"
                      type="text"
                      class="form-control"
                      id="inputPid"
                      placeholder="PID"
                      maxlength="11"
                      (input)="preventForbiddenCharacters($event, 'tel')"
                    />
                    <label for="inputPid">{{ "agbCode" | translate }}</label>
                    <div *ngIf="isControlInvalid('pid')" class="text-danger">
                      <div *ngIf="userForm.get('pid')?.errors?.['required']">
                        {{ "agbCodeIsRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('pid')?.errors?.['minlength']">
                        {{ "pidMustBeAtLeast6CharactersLong" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Date of Birth -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="dateOfBirth"
                      type="date"
                      class="form-control"
                      id="inputDob"
                      placeholder="Date of Birth"
                      [max]="maxDate"
                    />
                    <label for="inputDob">{{
                      "dateOfBirth" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('dateOfBirth')"
                      class="text-danger"
                    >
                      {{ "dateOfBirthIsRequired" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Phone Number -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="phoneNumber"
                      type="tel"
                      class="form-control"
                      id="inputTel"
                      placeholder="Tel. number"
                      maxlength="15"
                      (input)="preventForbiddenCharacters($event, 'tel')"
                    />
                    <label for="inputTel">{{
                      "phoneNumber" | translate
                    }}</label>
                    <div
                      *ngIf="isControlInvalid('phoneNumber')"
                      class="text-danger"
                    >
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['required']"
                      >
                        {{ "phoneNumberIsRequired" | translate }}
                      </div>
                      <div
                        *ngIf="userForm.get('phoneNumber')?.errors?.['pattern']"
                      >
                        {{ "phoneNumberIsNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Email -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="email"
                      type="email"
                      class="form-control"
                      id="inputEmail"
                      placeholder="Email"
                      (input)="preventForbiddenCharacters($event, 'email')"
                    />
                    <label for="inputEmail">{{ "email" | translate }}</label>
                    <div *ngIf="isControlInvalid('email')" class="text-danger">
                      <div *ngIf="userForm.get('email')?.errors?.['required']">
                        {{ "emailIsRequired" | translate }}
                      </div>
                      <div *ngIf="userForm.get('email')?.errors?.['email']">
                        {{ "emailIsNotValid" | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-5">
                <div class="text-end">
                  <button
                    type="submit"
                    class="btn btn-dark btn-sm cursor-pointer"
                  >
                    {{ "save" | translate }}
                    <i class="ki-duotone ki-arrow-right fs-2x"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
